import { AuthCallbackRedirect } from "../../features/auth";

const AuthCallbackPage = () => {
    return (
        <AuthCallbackRedirect />
    );
};

export default AuthCallbackPage;